import { render, staticRenderFns } from "./introList.vue?vue&type=template&id=2ff1d70f&scoped=true&"
import script from "./introList.vue?vue&type=script&lang=js&"
export * from "./introList.vue?vue&type=script&lang=js&"
import style0 from "./introList.vue?vue&type=style&index=0&id=2ff1d70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1d70f",
  null
  
)

export default component.exports